export default "<app-header></app-header>\r\n<app-mainmenu></app-mainmenu>\r\n<app-loading></app-loading>\r\n<router-outlet></router-outlet>";